// @ts-nocheck
import React from 'react';
import { Route, Navigate, Routes } from 'react-router-dom';
import RoutePrivate from 'components/Route/Private/Private';
import ScreensProductionCreate from './Create/ScreensProductionCreate';
import ScreensProductionForm from './Form/ScreensProductionForm';
import ScreensProductionsView from './View/ScreensProductionsView';
import ScreensProductionsList from './List/ScreensProductionsList';
import ScreensProductionLinked from './Linked/ScreensProductionLinked';

const ScreensProductions: React.FC = () => (
  <Routes>
    <Route
      path="/create"
      element={
        <RoutePrivate
          element={ScreensProductionCreate}
          requiredPermission="productions.create"
        />
      }
    />
    <Route
      path="/:id/edit"
      element={
        <RoutePrivate
          element={ScreensProductionForm}
          requiredPermission="productions.update"
        />
      }
    />
    <Route
      path="/:id/linked"
      element={
        <RoutePrivate
          element={ScreensProductionLinked}
          requiredPermission="productions.update"
        />
      }
    />
    <Route
      path="/list"
      element={
        <RoutePrivate
          element={ScreensProductionsList}
          requiredPermission="productions.manage"
        />
      }
    />
    <Route
      path="/:id/*"
      element={
        <RoutePrivate
          element={ScreensProductionsView}
          requiredPermission="productions.read"
        />
      }
    />
    <Route path="/" element={<Navigate replace to="/productions/list" />} />
  </Routes>
);

export default ScreensProductions;
